import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { withExperience } from '@helpcenter/analytics-components/src/experience';
import { ExperienceName } from '@helpcenter/constants';
import { editingHelpCenter } from '@helpcenter/help-center-preview';
import { getIsPortalHidingEnabled } from 'state/selectors/featured-and-sorted-portals';
import {
    getSharedPortalName,
    getCanCustomize,
    getHelpCenterTitle,
    getHelpCenterTitleColor,
} from 'state/selectors/help-center';
import { isCustomizing } from 'state/selectors/help-center-preview';
import { getShown as getSearchShown } from 'state/selectors/search';
import { getCanAdministerJIRA } from 'state/selectors/user';
import { LazyPushingCustomizeSidebar } from 'view/common/pushing-customize-sidebar';
import HelpCenterComponent from './help-center';

const selector = createSelector(
    getSharedPortalName,
    getCanCustomize,
    getHelpCenterTitle,
    getHelpCenterTitleColor,
    // Do not remove getSearchShown here, even it it's unused.
    // It affects the render order which the search animation relies upon.
    // No longer required with react-redux 6.0.0: see FSD-3282
    getSearchShown,
    isCustomizing,
    getCanAdministerJIRA,
    getIsPortalHidingEnabled,
    (
        sharedPortalName,
        canCustomize,
        helpCenterTitle,
        helpCenterTitleColor,
        searchBarShown,
        customizing,
        canAdministerJira,
        isPortalHidingEnabled
    ) => ({
        isPortalHidingEnabled,
        sharedPortalName,
        helpCenterTitle,
        searchBarShown,
        canAdministerJira,
        PushingCustomizeSidebar: LazyPushingCustomizeSidebar,
        titleColor: helpCenterTitleColor,
        showCustomizeSidebar: canCustomize,
        isCustomizing: customizing,
    })
);

export const HelpCenter = connect(selector, {
    onStartEditing: () => editingHelpCenter(true),
    onFinishEditing: () => editingHelpCenter(false),
})(withExperience(ExperienceName.HELP_CENTER)(HelpCenterComponent));
